import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    FaCalculator,
    FaFileAlt,
    FaMoneyBillWave,
    FaCheckCircle,
    FaDownload,
    FaQuestionCircle,
    FaLandmark,
    FaBuilding,
    FaClipboardList,
    FaClock,
    FaCalendarCheck,
    FaPhone,
    FaWhatsapp,
    FaSearch,
    FaInfoCircle,
    FaUser,
    FaDoorOpen,
    FaRulerCombined,
    FaCouch,
    FaWarehouse,
    FaStore,
    FaUsers,
    FaWifi,
    FaCar,
    FaSnowflake,
    FaDesktop,
    FaChair
} from 'react-icons/fa';

const RetribusiIPR = () => {
    const [activeTab, setActiveTab] = useState('kalkulator');
    const [showForm, setShowForm] = useState(false);
    const [kalkulatorData, setKalkulatorData] = useState({
        luasRuangan: '',
        jenisRuangan: 'pertokoan',
        zona: 'pusat',
        fasilitas: [],
        jangkaWaktu: '1'
    });
    const [hasilKalkulasi, setHasilKalkulasi] = useState(null);

    const tabs = [
        { id: 'kalkulator', label: 'Kalkulator Retribusi', icon: FaCalculator },
        { id: 'ketentuan', label: 'Ketentuan & Tarif', icon: FaClipboardList },
        { id: 'prosedur', label: 'Prosedur Pembayaran', icon: FaMoneyBillWave },
        { id: 'pembayaran', label: 'Pembayaran Online', icon: FaLandmark },
    ];

    const jenisRuanganOptions = [
        {
            value: 'pertokoan',
            label: 'Ruang Pertokoan',
            tarifDasar: 75000,
            deskripsi: 'Ruko, toko, butik, showroom',
            icon: FaStore,
            fasilitas: ['AC', 'Listrik', 'Air', 'Parkir']
        },
        {
            value: 'perkantoran',
            label: 'Ruang Perkantoran',
            tarifDasar: 60000,
            deskripsi: 'Kantor, co-working space, agen',
            icon: FaBuilding,
            fasilitas: ['AC', 'Listrik', 'Internet', 'Parkir']
        },
        {
            value: 'gudang',
            label: 'Ruang Gudang',
            tarifDasar: 35000,
            deskripsi: 'Gudang, storage, tempat penyimpanan',
            icon: FaWarehouse,
            fasilitas: ['Listrik', 'Akses 24 Jam']
        },
        {
            value: 'aula',
            label: 'Aula/Ruang Pertemuan',
            tarifDasar: 100000,
            deskripsi: 'Aula, ballroom, ruang seminar',
            icon: FaUsers,
            fasilitas: ['AC', 'Sound System', 'Proyektor', 'Kursi']
        },
        {
            value: 'ruang_usaha',
            label: 'Ruang Usaha Kecil',
            tarifDasar: 45000,
            deskripsi: 'Kios, stan, booth, gerai',
            icon: FaStore,
            fasilitas: ['Listrik', 'Air']
        }
    ];

    const zonaOptions = [
        { value: 'pusat', label: 'Pusat Kota', koefisien: 1.5, deskripsi: 'Jl. Jend. Sudirman, Alun-alun, Pecinan' },
        { value: 'menengah', label: 'Zona Menengah', koefisien: 1.2, deskripsi: 'Kawasan perumahan dan bisnis menengah' },
        { value: 'pinggiran', label: 'Zona Pinggiran', koefisien: 1.0, deskripsi: 'Kawasan pinggiran dan pemukiman' }
    ];

    const fasilitasOptions = [
        { value: 'ac', label: 'AC', biaya: 50000, icon: FaSnowflake },
        { value: 'internet', label: 'Internet', biaya: 30000, icon: FaWifi },
        { value: 'parkir', label: 'Parkir', biaya: 25000, icon: FaCar },
        { value: 'komputer', label: 'Komputer', biaya: 75000, icon: FaDesktop },
        { value: 'mebel', label: 'Mebel/Mebeler', biaya: 50000, icon: FaChair },
        { value: 'gudang', label: 'Ruang Penyimpanan', biaya: 35000, icon: FaWarehouse }
    ];

    const hitungRetribusi = () => {
        const luas = parseFloat(kalkulatorData.luasRuangan) || 0;
        const jenis = jenisRuanganOptions.find(j => j.value === kalkulatorData.jenisRuangan);
        const zona = zonaOptions.find(z => z.value === kalkulatorData.zona);
        const tahun = parseInt(kalkulatorData.jangkaWaktu);

        const tarifDasar = jenis.tarifDasar;
        const koefisienZona = zona.koefisien;
        const biayaFasilitas = kalkulatorData.fasilitas.reduce((total, fas) => {
            const fasilitas = fasilitasOptions.find(f => f.value === fas);
            return total + (fasilitas ? fasilitas.biaya : 0);
        }, 0);

        const retribusiPerBulan = (luas * tarifDasar * koefisienZona) + biayaFasilitas;
        const retribusiPerTahun = retribusiPerBulan * 12;
        const totalRetribusi = retribusiPerTahun * tahun;
        const biayaAdmin = 50000;
        const biayaSurvey = luas > 50 ? 100000 : 75000;
        const deposit = retribusiPerBulan * 2; // Deposit 2 bulan
        const grandTotal = totalRetribusi + biayaAdmin + biayaSurvey + deposit;

        setHasilKalkulasi({
            luas,
            tarifDasar,
            koefisienZona,
            retribusiPerBulan,
            retribusiPerTahun,
            totalRetribusi,
            biayaAdmin,
            biayaSurvey,
            deposit,
            grandTotal,
            tahun,
            jenisRuangan: jenis.label,
            zona: zona.label,
            fasilitas: kalkulatorData.fasilitas.map(f => {
                const fas = fasilitasOptions.find(opt => opt.value === f);
                return fas ? fas.label : f;
            }),
            biayaFasilitas
        });
    };

    const handleFasilitasChange = (e) => {
        const { value, checked } = e.target;
        setKalkulatorData(prev => ({
            ...prev,
            fasilitas: checked
                ? [...prev.fasilitas, value]
                : prev.fasilitas.filter(f => f !== value)
        }));
    };

    const ketentuanList = [
        {
            judul: "Dasar Hukum",
            icon: FaFileAlt,
            items: [
                "Peraturan Daerah Kota Magelang No. 5 Tahun 2023 tentang Retribusi Daerah",
                "Peraturan Walikota Magelang No. 12 Tahun 2023 tentang Petunjuk Teknis Pemungutan Retribusi",
                "Keputusan Kepala BPKAD No. 189/2024 tentang Standar Operasional Prosedur IPR"
            ]
        },
        {
            judul: "Subjek Retribusi",
            icon: FaUser,
            items: [
                "Perseorangan (WNI/WNA yang memiliki KTP/identitas resmi)",
                "Badan Usaha (PT, CV, Koperasi, Yayasan)",
                "Instansi Pemerintah/Swasta",
                "UMKM dan Pelaku Usaha Kecil"
            ]
        },
        {
            judul: "Objek Retribusi",
            icon: FaBuilding,
            items: [
                "Ruang pertokoan milik Pemkot Magelang",
                "Ruang perkantoran di gedung pemerintah",
                "Aula dan ruang pertemuan",
                "Gudang dan tempat penyimpanan",
                "Kios, stan, dan booth di area publik"
            ]
        }
    ];

    const prosedurPembayaran = [
        {
            step: 1,
            title: "Dapatkan SKRD",
            description: "Ambil Surat Ketetapan Retribusi Daerah (SKRD) di kantor BPKAD setelah permohonan IPR disetujui",
            icon: FaFileAlt,
            durasi: "1 hari kerja"
        },
        {
            step: 2,
            title: "Verifikasi Tagihan",
            description: "Periksa rincian tagihan retribusi yang tertera di SKRD, pastikan sesuai dengan perhitungan dan fasilitas yang digunakan",
            icon: FaClipboardList,
            durasi: "Langsung"
        },
        {
            step: 3,
            title: "Lakukan Pembayaran",
            description: "Bayar melalui Bank Jateng, BNI, BRI, atau channel pembayaran online yang tersedia",
            icon: FaMoneyBillWave,
            durasi: "1 hari kerja"
        },
        {
            step: 4,
            title: "Pembayaran Deposit",
            description: "Lakukan pembayaran deposit sewa sebesar 2 bulan retribusi (akan dikembalikan saat masa sewa berakhir)",
            icon: FaLandmark,
            durasi: "Bersamaan dengan pembayaran"
        },
        {
            step: 5,
            title: "Verifikasi & Serah Terima",
            description: "Konfirmasi pembayaran ke petugas, tanda tangan berita acara serah terima kunci dan dapatkan Izin Pemakaian Ruangan",
            icon: FaCalendarCheck,
            durasi: "1-2 jam"
        }
    ];

    const metodePembayaran = [
        { bank: "Bank Jateng", kode: "001", rekening: "1-001-23456-8", logo: "🏦" },
        { bank: "BNI", kode: "009", rekening: "0123456790", logo: "🏦" },
        { bank: "BRI", kode: "002", rekening: "0123-01-000002-50-1", logo: "🏦" },
        { bank: "QRIS", kode: "QR", rekening: "Scan QR Code", logo: "📱" },
    ];

    const faqList = [
        {
            question: "Bagaimana cara menghitung retribusi IPR?",
            answer: "Retribusi IPR dihitung berdasarkan: (Luas Ruangan × Tarif Dasar Jenis Ruangan × Koefisien Zona) + Biaya Fasilitas Tambahan. Gunakan kalkulator retribusi di halaman ini untuk perhitungan detail."
        },
        {
            question: "Apa itu deposit sewa dan kapan dikembalikan?",
            answer: "Deposit sewa adalah jaminan sebesar 2 bulan retribusi yang dibayarkan di awal. Deposit akan dikembalikan 100% saat masa sewa berakhir jika tidak ada kerusakan dan tunggakan."
        },
        {
            question: "Apakah bisa pindah ruangan di tengah masa sewa?",
            answer: "Pemindahan ruangan di tengah masa sewa dapat dilakukan dengan mengajukan permohonan baru dan membayar selisih retribusi (jika ada). Biaya administrasi pemindahan sebesar Rp 100.000."
        },
        {
            question: "Bagaimana prosedur perpanjangan sewa?",
            answer: "Perpanjangan sewa dapat diajukan 1 bulan sebelum masa sewa berakhir. Pemohon yang sedang menyewa mendapat prioritas perpanjangan."
        },
        {
            question: "Apakah boleh merenovasi ruangan yang disewa?",
            answer: "Renovasi ringan diperbolehkan dengan izin tertulis dari BPKAD. Renovasi besar (mengubah struktur) tidak diperbolehkan. Semua biaya renovasi ditanggung penyewa."
        },
        {
            question: "Bagaimana jika terjadi kerusakan fasilitas?",
            answer: "Kerusakan karena pemakaian wajar menjadi tanggung jawab BPKAD. Kerusakan karena kelalaian penyewa akan diperbaiki dengan biaya dari deposit atau ditagihkan ke penyewa."
        }
    ];

    return (
        <div className="container mx-auto px-4 py-12">
            {/* Header */}
            <div className="mb-8">
                <div className="flex items-center space-x-3 mb-4">
                    <FaBuilding className="text-4xl text-[#0D9488]" />
                    <h1 className="text-3xl md:text-4xl font-bold text-[#1E3A8A]">
                        Retribusi Izin Pemakaian Ruangan (IPR)
                    </h1>
                </div>
                <p className="text-gray-600 text-lg">
                    Informasi dan layanan pembayaran retribusi pemakaian ruangan/gedung aset Pemerintah Kota Magelang
                </p>
            </div>

            {/* Tab Navigation */}
            <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center px-6 py-3 text-sm font-medium transition-all duration-200 border-b-2 ${activeTab === tab.id
                                ? 'border-[#0D9488] text-[#0D9488] bg-[#0D9488]/5'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        <tab.icon className="mr-2" />
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div className="space-y-8">
                {/* Kalkulator Retribusi */}
                {activeTab === 'kalkulator' && (
                    <div>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            {/* Form Kalkulator */}
                            <div className="card-glass">
                                <h3 className="text-xl font-bold text-[#1E3A8A] mb-6 flex items-center">
                                    <FaCalculator className="mr-2 text-[#0D9488]" />
                                    Kalkulator Retribusi IPR
                                </h3>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Jenis Ruangan *
                                        </label>
                                        <select
                                            value={kalkulatorData.jenisRuangan}
                                            onChange={(e) => setKalkulatorData({ ...kalkulatorData, jenisRuangan: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            {jenisRuanganOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>
                                                    {opt.label} (Rp {opt.tarifDasar.toLocaleString()}/m²/bulan)
                                                </option>
                                            ))}
                                        </select>
                                        <p className="text-xs text-gray-500 mt-1">
                                            {jenisRuanganOptions.find(j => j.value === kalkulatorData.jenisRuangan)?.deskripsi}
                                        </p>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Luas Ruangan (m²) *
                                        </label>
                                        <div className="relative">
                                            <input
                                                type="number"
                                                value={kalkulatorData.luasRuangan}
                                                onChange={(e) => setKalkulatorData({ ...kalkulatorData, luasRuangan: e.target.value })}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                placeholder="Masukkan luas ruangan"
                                            />
                                            <span className="absolute right-3 top-2 text-gray-400">m²</span>
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Zona Lokasi *
                                        </label>
                                        <select
                                            value={kalkulatorData.zona}
                                            onChange={(e) => setKalkulatorData({ ...kalkulatorData, zona: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            {zonaOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>
                                                    {opt.label} (Koef. {opt.koefisien}x)
                                                </option>
                                            ))}
                                        </select>
                                        <p className="text-xs text-gray-500 mt-1">
                                            {zonaOptions.find(z => z.value === kalkulatorData.zona)?.deskripsi}
                                        </p>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-3">
                                            Fasilitas Tambahan
                                        </label>
                                        <div className="grid grid-cols-2 gap-3">
                                            {fasilitasOptions.map(fasilitas => (
                                                <label key={fasilitas.value} className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        value={fasilitas.value}
                                                        checked={kalkulatorData.fasilitas.includes(fasilitas.value)}
                                                        onChange={handleFasilitasChange}
                                                        className="mr-2 text-[#0D9488] focus:ring-[#0D9488]"
                                                    />
                                                    <fasilitas.icon className="text-gray-600 mr-2" />
                                                    <div>
                                                        <span className="text-sm font-medium text-gray-700">{fasilitas.label}</span>
                                                        <p className="text-xs text-gray-500">+Rp {fasilitas.biaya.toLocaleString()}/bln</p>
                                                    </div>
                                                </label>
                                            ))}
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Jangka Waktu Sewa *
                                        </label>
                                        <select
                                            value={kalkulatorData.jangkaWaktu}
                                            onChange={(e) => setKalkulatorData({ ...kalkulatorData, jangkaWaktu: e.target.value })}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                        >
                                            <option value="1">1 Tahun</option>
                                            <option value="2">2 Tahun</option>
                                            <option value="3">3 Tahun</option>
                                            <option value="5">5 Tahun</option>
                                        </select>
                                    </div>

                                    <button
                                        onClick={hitungRetribusi}
                                        className="btn-primary w-full flex items-center justify-center"
                                    >
                                        <FaCalculator className="mr-2" />
                                        Hitung Retribusi
                                    </button>
                                </div>
                            </div>

                            {/* Hasil Kalkulasi */}
                            <div>
                                {hasilKalkulasi ? (
                                    <div className="card-glass">
                                        <h3 className="text-xl font-bold text-[#1E3A8A] mb-6">Hasil Kalkulasi</h3>

                                        <div className="space-y-4">
                                            <div className="bg-gray-50 p-4 rounded-lg">
                                                <h4 className="font-semibold text-[#1E3A8A] mb-3">Informasi Ruangan</h4>
                                                <div className="grid grid-cols-2 gap-3 text-sm">
                                                    <div>
                                                        <span className="text-gray-600">Jenis Ruangan:</span>
                                                        <p className="font-semibold">{hasilKalkulasi.jenisRuangan}</p>
                                                    </div>
                                                    <div>
                                                        <span className="text-gray-600">Luas:</span>
                                                        <p className="font-semibold">{hasilKalkulasi.luas} m²</p>
                                                    </div>
                                                    <div>
                                                        <span className="text-gray-600">Zona:</span>
                                                        <p className="font-semibold">{hasilKalkulasi.zona}</p>
                                                    </div>
                                                    <div>
                                                        <span className="text-gray-600">Jangka Waktu:</span>
                                                        <p className="font-semibold">{hasilKalkulasi.tahun} tahun</p>
                                                    </div>
                                                </div>
                                                {hasilKalkulasi.fasilitas.length > 0 && (
                                                    <div className="mt-2">
                                                        <span className="text-gray-600 text-sm">Fasilitas:</span>
                                                        <div className="flex flex-wrap gap-1 mt-1">
                                                            {hasilKalkulasi.fasilitas.map((fas, idx) => (
                                                                <span key={idx} className="bg-[#0D9488]/10 text-[#0D9488] text-xs px-2 py-1 rounded-full">
                                                                    {fas}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="bg-green-50 p-4 rounded-lg">
                                                <h4 className="font-semibold text-green-800 mb-3">Rincian Biaya</h4>
                                                <div className="space-y-2 text-sm">
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Tarif Dasar:</span>
                                                        <span>Rp {hasilKalkulasi.tarifDasar.toLocaleString()} /m²/bulan</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Koefisien Zona:</span>
                                                        <span>{hasilKalkulasi.koefisienZona}x</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Retribusi per Bulan:</span>
                                                        <span>Rp {hasilKalkulasi.retribusiPerBulan.toLocaleString()}</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Retribusi per Tahun:</span>
                                                        <span>Rp {hasilKalkulasi.retribusiPerTahun.toLocaleString()}</span>
                                                    </div>
                                                    <div className="flex justify-between font-semibold">
                                                        <span>Total Retribusi ({hasilKalkulasi.tahun} tahun):</span>
                                                        <span>Rp {hasilKalkulasi.totalRetribusi.toLocaleString()}</span>
                                                    </div>
                                                    <hr className="border-green-200" />
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Biaya Administrasi:</span>
                                                        <span>Rp {hasilKalkulasi.biayaAdmin.toLocaleString()}</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Biaya Survey:</span>
                                                        <span>Rp {hasilKalkulasi.biayaSurvey.toLocaleString()}</span>
                                                    </div>
                                                    <div className="flex justify-between text-orange-600">
                                                        <span>Deposit (2 bulan):</span>
                                                        <span>Rp {hasilKalkulasi.deposit.toLocaleString()}</span>
                                                    </div>
                                                    <hr className="border-green-200" />
                                                    <div className="flex justify-between text-lg font-bold text-green-800">
                                                        <span>Grand Total:</span>
                                                        <span>Rp {hasilKalkulasi.grandTotal.toLocaleString()}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="bg-yellow-50 p-4 rounded-lg">
                                                <p className="text-sm text-yellow-800 flex items-start">
                                                    <FaInfoCircle className="mr-2 mt-0.5 flex-shrink-0" />
                                                    Hasil kalkulasi adalah estimasi. Deposit akan dikembalikan saat masa sewa berakhir. Nilai pasti akan ditetapkan dalam SKRD oleh petugas BPKAD.
                                                </p>
                                            </div>

                                            <Link to="/layanan/ajukan-permohonan-ipr" className="btn-primary w-full inline-block text-center">
                                                <FaFileAlt className="mr-2 inline" />
                                                Ajukan Permohonan IPR
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card-glass h-full flex items-center justify-center">
                                        <div className="text-center text-gray-400">
                                            <FaCalculator className="text-6xl mx-auto mb-4" />
                                            <p className="text-lg">Masukkan data ruangan dan klik "Hitung Retribusi"</p>
                                            <p className="text-sm mt-2">untuk melihat estimasi biaya retribusi</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Info Jenis Ruangan */}
                        <div className="mt-8">
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-6">Jenis Ruangan & Tarif Dasar</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {jenisRuanganOptions.map((jenis) => (
                                    <div key={jenis.value} className="card-glass hover:transform hover:scale-105 transition-all duration-300">
                                        <div className="flex items-center mb-3">
                                            <div className="w-12 h-12 bg-[#0D9488]/10 rounded-full flex items-center justify-center mr-3">
                                                <jenis.icon className="text-xl text-[#0D9488]" />
                                            </div>
                                            <div>
                                                <h4 className="font-bold text-[#1E3A8A]">{jenis.label}</h4>
                                                <p className="text-xs text-gray-500">{jenis.deskripsi}</p>
                                            </div>
                                        </div>
                                        <div className="bg-gray-50 p-3 rounded-lg">
                                            <p className="text-lg font-bold text-[#0D9488]">
                                                Rp {jenis.tarifDasar.toLocaleString()}
                                            </p>
                                            <p className="text-xs text-gray-500">per m² per bulan</p>
                                        </div>
                                        <div className="mt-3">
                                            <p className="text-xs font-semibold text-gray-600 mb-2">Fasilitas Dasar:</p>
                                            <div className="flex flex-wrap gap-1">
                                                {jenis.fasilitas.map((fas, idx) => (
                                                    <span key={idx} className="bg-blue-50 text-blue-700 text-xs px-2 py-1 rounded-full">
                                                        {fas}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* Ketentuan Tab */}
                {activeTab === 'ketentuan' && (
                    <div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                            {ketentuanList.map((ketentuan, index) => (
                                <div key={index} className="card-glass">
                                    <div className="flex items-center mb-4">
                                        <div className="w-12 h-12 bg-[#0D9488]/10 rounded-full flex items-center justify-center mr-3">
                                            <ketentuan.icon className="text-xl text-[#0D9488]" />
                                        </div>
                                        <h3 className="text-lg font-bold text-[#1E3A8A]">{ketentuan.judul}</h3>
                                    </div>
                                    <ul className="space-y-2">
                                        {ketentuan.items.map((item, idx) => (
                                            <li key={idx} className="flex items-start text-sm">
                                                <FaCheckCircle className="text-[#0D9488] mt-1 mr-2 flex-shrink-0" />
                                                <span className="text-gray-700">{item}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>

                        {/* Tabel Tarif Lengkap */}
                        <div className="card-glass overflow-x-auto">
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-4">Tabel Tarif Retribusi IPR Lengkap</h3>
                            <table className="w-full">
                                <thead>
                                    <tr className="bg-[#1E3A8A] text-white">
                                        <th className="px-4 py-3 text-left text-sm">Jenis Ruangan</th>
                                        <th className="px-4 py-3 text-right text-sm">Pusat Kota</th>
                                        <th className="px-4 py-3 text-right text-sm">Zona Menengah</th>
                                        <th className="px-4 py-3 text-right text-sm">Zona Pinggiran</th>
                                        <th className="px-4 py-3 text-left text-sm">Fasilitas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jenisRuanganOptions.map((jenis) => (
                                        <tr key={jenis.value} className="border-b hover:bg-gray-50">
                                            <td className="px-4 py-3 font-semibold text-[#1E3A8A]">
                                                {jenis.label}
                                                <p className="text-xs text-gray-500">{jenis.deskripsi}</p>
                                            </td>
                                            {zonaOptions.map((zona) => (
                                                <td key={zona.value} className="px-4 py-3 text-right font-semibold">
                                                    Rp {(jenis.tarifDasar * zona.koefisien).toLocaleString()}
                                                    <p className="text-xs text-gray-500">/m²/bulan</p>
                                                </td>
                                            ))}
                                            <td className="px-4 py-3">
                                                <div className="flex flex-wrap gap-1">
                                                    {jenis.fasilitas.map((fas, idx) => (
                                                        <span key={idx} className="bg-green-50 text-green-700 text-xs px-2 py-1 rounded-full">
                                                            {fas}
                                                        </span>
                                                    ))}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="mt-4 p-4 bg-blue-50 rounded-lg">
                                <p className="text-sm text-blue-800">
                                    <FaInfoCircle className="inline mr-2" />
                                    Fasilitas tambahan di luar fasilitas dasar dikenakan biaya terpisah sesuai daftar fasilitas tambahan.
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Prosedur Pembayaran Tab */}
                {activeTab === 'prosedur' && (
                    <div>
                        <div className="relative">
                            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-[#0D9488]/20 hidden md:block"></div>

                            <div className="space-y-8">
                                {prosedurPembayaran.map((prosedur, index) => (
                                    <div key={index} className="relative flex items-start">
                                        <div className="flex-shrink-0 w-16 h-16 bg-[#0D9488] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg z-10">
                                            {prosedur.step}
                                        </div>

                                        <div className="ml-6 card-glass flex-1">
                                            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3">
                                                <h3 className="text-xl font-bold text-[#1E3A8A] flex items-center">
                                                    <prosedur.icon className="mr-2 text-[#0D9488]" />
                                                    {prosedur.title}
                                                </h3>
                                                <span className="text-sm bg-[#0D9488]/10 text-[#0D9488] px-3 py-1 rounded-full font-medium mt-2 md:mt-0 inline-block w-fit">
                                                    <FaClock className="inline mr-1" />
                                                    {prosedur.durasi}
                                                </span>
                                            </div>
                                            <p className="text-gray-600">{prosedur.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* Pembayaran Online Tab */}
                {activeTab === 'pembayaran' && (
                    <div>
                        <div className="card-glass mb-8">
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-4">Metode Pembayaran</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {metodePembayaran.map((metode, index) => (
                                    <div key={index} className="flex items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                                        <span className="text-4xl mr-4">{metode.logo}</span>
                                        <div>
                                            <p className="font-semibold text-gray-800">{metode.bank}</p>
                                            <p className="text-sm text-gray-600">Kode Bank: {metode.kode}</p>
                                            <p className="text-sm text-gray-600">No. Rek: {metode.rekening}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-4 p-4 bg-yellow-50 rounded-lg">
                                <p className="text-sm text-yellow-800">
                                    <FaInfoCircle className="inline mr-2" />
                                    Cantumkan Nomor SKRD pada berita transfer untuk memudahkan verifikasi pembayaran.
                                </p>
                            </div>
                        </div>

                        {/* Form Konfirmasi Pembayaran */}
                        <div className="card-glass">
                            <div className="flex justify-between items-center mb-6">
                                <h3 className="text-xl font-bold text-[#1E3A8A]">Konfirmasi Pembayaran IPR</h3>
                                <button
                                    onClick={() => setShowForm(!showForm)}
                                    className="btn-primary"
                                >
                                    {showForm ? 'Tutup Form' : 'Konfirmasi Sekarang'}
                                </button>
                            </div>

                            {showForm && (
                                <form className="space-y-4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">No. SKRD *</label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                placeholder="Masukkan nomor SKRD"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Nama Penyewa *</label>
                                            <input
                                                type="text"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                placeholder="Masukkan nama penyewa"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Tanggal Pembayaran *</label>
                                            <input
                                                type="date"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Jumlah Dibayar *</label>
                                            <input
                                                type="number"
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                                placeholder="Masukkan jumlah pembayaran"
                                            />
                                        </div>
                                        <div className="md:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Upload Bukti Pembayaran *</label>
                                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-[#0D9488] transition-colors cursor-pointer">
                                                <FaDownload className="mx-auto text-3xl text-gray-400 mb-2" />
                                                <p className="text-sm text-gray-500">
                                                    Upload bukti transfer/foto bukti pembayaran
                                                </p>
                                                <p className="text-xs text-gray-400 mt-1">
                                                    Format: JPG, PNG, PDF (Maks. 2MB)
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn-primary w-full">
                                        Kirim Konfirmasi
                                    </button>
                                </form>
                            )}
                        </div>

                        {/* Cek Status */}
                        <div className="mt-8 card-glass">
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-4 flex items-center">
                                <FaSearch className="mr-2 text-[#0D9488]" />
                                Cek Status Pembayaran IPR
                            </h3>
                            <div className="flex gap-4">
                                <input
                                    type="text"
                                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0D9488] focus:border-transparent"
                                    placeholder="Masukkan No. SKRD atau NIK Penyewa"
                                />
                                <button className="btn-primary">
                                    <FaSearch className="mr-2 inline" />
                                    Cek Status
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* FAQ Section */}
            <div className="mt-12">
                <h2 className="text-2xl font-bold text-[#1E3A8A] mb-6 flex items-center">
                    <FaQuestionCircle className="mr-2 text-[#0D9488]" />
                    Pertanyaan Umum (FAQ) IPR
                </h2>
                <div className="space-y-4">
                    {faqList.map((faq, index) => (
                        <details key={index} className="card-glass group cursor-pointer">
                            <summary className="flex justify-between items-center list-none">
                                <span className="text-lg font-semibold text-[#1E3A8A]">{faq.question}</span>
                                <span className="text-[#0D9488] group-open:rotate-180 transition-transform text-xl">
                                    ▼
                                </span>
                            </summary>
                            <p className="mt-3 text-gray-600 pl-2 border-l-4 border-[#0D9488]">
                                {faq.answer}
                            </p>
                        </details>
                    ))}
                </div>
            </div>

            {/* Contact Section */}
            <div className="mt-12 card-glass bg-gradient-to-r from-[#1E3A8A] to-[#0D9488] text-white">
                <div className="text-center">
                    <h3 className="text-2xl font-bold mb-4">Butuh Bantuan Terkait IPR?</h3>
                    <p className="mb-6">Tim kami siap membantu Anda dalam proses sewa ruangan dan pembayaran retribusi IPR</p>
                    <div className="flex flex-col md:flex-row justify-center gap-4">
                        <button className="bg-white text-[#1E3A8A] px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors flex items-center justify-center">
                            <FaPhone className="mr-2" />
                            (0293) 123456
                        </button>
                        <button className="bg-green-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors flex items-center justify-center">
                            <FaWhatsapp className="mr-2" />
                            Chat WhatsApp
                        </button>
                    </div>
                    <p className="mt-4 text-sm opacity-80">
                        Jam operasional: Senin-Kamis 07.30-16.00 | Jumat 07.30-16.30
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RetribusiIPR;